// File: src/pages/TagPage.jsx
// نمایش جلسات یک برچسب خاص (از ?tag=شرق-تهران)

import { useTagMeetings } from '../hooks/useTags';
import MeetingCard from '../components/MeetingCard';
import { toPersian, isFastDevice } from '../data/constants';

const FAST = isFastDevice();

export default function TagPage({ slug, onClear }) {
  const { tag, meetings, loading, error } = useTagMeetings(slug);
  const color = tag?.color || '#0ea5e9';

  return (
    <div style={{ direction: 'rtl' }}>
      {/* هدر برچسب */}
      <div style={{
        display: 'flex', alignItems: 'center', gap: 12, marginBottom: 16,
        padding: '14px 16px', borderRadius: 16,
        background: `${color}12`, border: `1px solid ${color}30`,
      }}>
        <div style={{
          width: 44, height: 44, borderRadius: 12, flexShrink: 0,
          background: `${color}20`, border: `1.5px solid ${color}40`,
          display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 20,
        }}>🏷️</div>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ fontSize: 16, fontWeight: 900, color: 'var(--text)' }}>
            {tag?.name || (loading ? 'در حال بارگذاری...' : slug)}
          </div>
          {tag?.description && (
            <div style={{ fontSize: 11.5, color: 'var(--text2)', marginTop: 2 }}>{tag.description}</div>
          )}
          {!loading && (
            <div style={{ fontSize: 11, color, fontWeight: 700, marginTop: 3 }}>
              {toPersian(meetings.length)} جلسه با این برچسب
            </div>
          )}
        </div>
        {onClear && (
          <button onClick={onClear} style={{
            background: 'var(--bg2)', border: '1px solid var(--border)', borderRadius: 10,
            padding: '7px 12px', fontSize: 12, fontWeight: 700, color: 'var(--text2)',
            cursor: 'pointer', fontFamily: 'inherit', flexShrink: 0,
          }}>✕ همه جلسات</button>
        )}
      </div>

      {/* محتوا */}
      {loading ? (
        <div style={{ padding: '50px 0', textAlign: 'center' }}>
          <div style={{
            width: 30, height: 30, margin: '0 auto 12px',
            border: '3px solid var(--border)', borderTop: `3px solid ${color}`,
            borderRadius: '50%', animation: 'spin 1s linear infinite',
          }} />
          <p style={{ color: 'var(--text3)', fontSize: 12 }}>در حال دریافت جلسات...</p>
        </div>
      ) : error ? (
        <div style={{ padding: '50px 20px', textAlign: 'center' }}>
          <div style={{ fontSize: 40, marginBottom: 12 }}>🏷️</div>
          <p style={{ color: 'var(--text2)', fontSize: 13, marginBottom: 10 }}>{error}</p>
          {onClear && (
            <button onClick={onClear} style={{
              fontSize: 12, color, background: 'none', border: 'none', cursor: 'pointer', fontWeight: 700,
            }}>بازگشت به همه جلسات</button>
          )}
        </div>
      ) : meetings.length === 0 ? (
        <div style={{ padding: '50px 0', textAlign: 'center', opacity: .5 }}>
          <div style={{ fontSize: 40, marginBottom: 12 }}>📭</div>
          <p style={{ color: 'var(--text2)', fontSize: 13 }}>جلسه‌ای با این برچسب ثبت نشده است</p>
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          {meetings.map((m, i) => (
            <div key={m.id}
              className={FAST ? 'card-zip' : undefined}
              style={FAST
                ? { animationDelay: `${Math.min(i, 10) * 0.05}s` }
                : { animation: `slideUp .3s ease ${Math.min(i, 8) * 0.04}s both` }}>
              <MeetingCard meeting={m} />
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
